import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import I18n from "common/i18n";
import { btnDelay, useScale, usePlaySound } from "common/utils";
import { ParentGate } from "features/parent/ParentGate";
import { recordRegisterPromptShow, recordRegisterPromptClose } from "features/auth/registerAnalytics";
import { useShouldShowTrialNotice } from "./hooks";

const BALLOON_WIDTH = 760;
const BALLOON_HEIGHT = 100;

export const TrialNoticeBalloon = () => {
  const play = usePlaySound();
  const { scale } = useScale();
  const handleDialog = useDialog();
  const visible = useShouldShowTrialNotice();
  const location = useLocation();
  const [closed, setClosed] = useState(false);
  const [gateVisible, setGateVisible] = useState(false);

  useEffect(() => {
    setClosed(false);
  }, [location.pathname]);

  useEffect(() => {
    if (visible && !closed) {
      recordRegisterPromptShow("trial_notice_balloon");
    }
  }, [visible, closed, location.pathname]);

  if (!visible || closed) return null;

  const handleOpenGate = () => {
    btnDelay(() => {
      play();
      setGateVisible(true);
    });
  };

  const handleGateClose = () => {
    setGateVisible(false);
  };

  const handleGateConfirm = () => {
    setGateVisible(false);
    handleDialog({ type: DialogType.UNIVERSAL, value: false });
    handleDialog({
      type: DialogType.PARENT_REGISTRATION,
      value: true,
      args: { redirectAfterSuccess: "/parent", source: "trial_notice_balloon" },
    });
  };

  const handleClose = () => {
    play();
    recordRegisterPromptClose("trial_notice_balloon");
    setClosed(true);
  };

  return (
    <>
      <div
        className="!absolute z-[9998] alpha left-1/2 -translate-x-1/2"
        style={{
          top: 20 * scale,
          width: BALLOON_WIDTH * scale,
          height: BALLOON_HEIGHT * scale,
        }}
      >
        <div className="animate-fuwa-fuwa1 w-full h-full">
          <div
            className="!relative flex-col-center origin-top-left"
            style={{
              transform: `scale(${scale})`,
              width: BALLOON_WIDTH,
              height: BALLOON_HEIGHT,
            }}
          >
            <div
              onClick={handleClose}
              className="!relative w-full h-full rounded-xl border-solid border-white border-8 bg-orange-10 shadow-lg flex-row-el items-center justify-start gap-3 p-2 cursor-pointer"
            >
              <div className="flex-col-el flex-center shrink-0 w-14 h-14 rounded-xl bg-orange-100">
                <span className="material-symbols-outlined type-title text-white">
                  notification_important
                </span>
              </div>

              <div className="flex-col-el items-start justify-between flex-1 min-w-0 h-14">
                <p className="type-text type-body text-textcolor-black !text-left leading-tight w-full self-start">
                  {I18n.t("MSG_TRIAL_NOTICE_TITLE")}
                </p>
                <p className="type-text type-sm text-gray-100 !text-left leading-tight w-full self-start">
                  {I18n.t("MSG_TRIAL_NOTICE_FOR_KIDS")}
                </p>
              </div>

              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenGate();
                }}
                className="type-inherit-font shrink-0 cursor-pointer rounded-xl border-solid border-white border-4 bg-green-100 px-6 py-3 shadow-md active:opacity-70"
              >
                <p className="type-text type-body text-white">{I18n.t("MSG_TRIAL_NOTICE_CTA")}</p>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ParentGate visible={gateVisible} confirm={handleGateConfirm} close={handleGateClose} />
    </>
  );
};
